import { isDesktop } from 'react-device-detect';
import ErrorController from '../../controllers/ErrorController';
import MainGridController from '../../controllers/grid/MainGridController';
import { ErrorViewGrid } from './ErrorViewGrid';

let scale = isDesktop ? 1 : 2;
export const ErrorView = {
	name: 'error_holder',
	child: true,
	zIndex: 3,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: ErrorController,
			name: 'ErrorController',
			config: {
				item: 'texts',
				value: 'ERROR_TEXT',
				target: 'error_info'
			}
		},
		{
			Controller: MainGridController,
			name: 'MainGridController',
			config: ErrorViewGrid
		}
	],
	components: [
		{
			name: 'error_img',
			type: 'Sprite',
			components: [
				isDesktop
					? {
							name: 'error_img',
							type: 'AnimatedSprite',
							position: { x: -100, y: -35 },
							animation: {
								pattern: 'wpassive$.png',
								start: 0,
								end: 43,
								speed: 0.5,
								precision: 2,
								loop: true,
								// position: {
								//     x: 0,
								//     y: 0,
								// },
								scale: {
									x: scale,
									y: scale
								},
								anchor: {
									x: 0,
									y: 0
								}
							}
						}
					: {
							name: 'error_img',
							type: 'Sprite',
							position: { x: 50, y: -280 },
							img: 'main_character_m'
						}
			]
		},

		{
			name: 'error_info',
			type: 'Sprite',
			components: [
				{
					name: 'error_info_bg',
					type: 'Sprite',
					img: 'error_content_bg',
					anchor: { x: 0, y: 0 }
				},
				{
					name: 'texts',
					type: 'Sprite',
					position: {
						x: 1336 / 2, //width of error_info_bg SPRITE
						y: 34
					},
					components: [
						{
							name: 'ERROR_TEXT',
							type: 'Text',
							text: 'ERROR_TEXT'
						}
					]
				}
			]
		}
	]
};
